import { render, staticRenderFns } from "./ReserveTeachersDetails.vue?vue&type=template&id=7a077cfb&scoped=true"
import script from "./ReserveTeachersDetails.vue?vue&type=script&lang=js"
export * from "./ReserveTeachersDetails.vue?vue&type=script&lang=js"
import style0 from "./ReserveTeachersDetails.vue?vue&type=style&index=0&id=7a077cfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a077cfb",
  null
  
)

export default component.exports